import React from 'react'
import Create from '../../../components/pages/branches/create'
import Barcodes from './index'

export const paths = [
    {
        path: "/barcodes",
        component: Barcodes,
    },
]

export const BarcodesRouters = {
    icon: "barcode",
    path: "/barcodes",
    label: 'Cód. de barras',
    tree: [
    ]
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/routers.js